import { render, staticRenderFns } from "./Medicasure.vue?vue&type=template&id=da3a3f00&scoped=true"
import script from "./Medicasure.vue?vue&type=script&lang=js"
export * from "./Medicasure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da3a3f00",
  null
  
)

export default component.exports